import * as React from "react";
import { Typography } from "@mui/material";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import HomeIcon from "@mui/icons-material/Home";
import { useResource, Resources } from "Translations/Resources";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import { BlButton } from "Components/Shared/Buttons/BlButton";

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
`;

const StyledIcon = styled(NotInterestedIcon)`
  margin: 20px;
  font-size: 120px;
`;

export const Error404Page: React.FunctionComponent = _ => {
  const { t } = useResource();
  const location = useLocation();

  return (
    <UnauthenticatedLayout title={"404"}>
      <StyledPage>
        <Typography variant="h1">Error 404</Typography>
        <Typography variant="h2">{location.pathname}</Typography>
        <Typography variant="h2">
          {t(Resources.Errors.Error404.Subtitle)}
        </Typography>
        <StyledIcon />
        <UnstyledLink to="/">
          <BlButton
            startIcon={<HomeIcon />}
            size="large"
            variant="contained"
            color="primary"
          >
            {t(Resources.Errors.Error404.Home)}
          </BlButton>
        </UnstyledLink>
      </StyledPage>
    </UnauthenticatedLayout>
  );
};

export default Error404Page;
